import React from 'react';

import './App.css';
import Home from './componentes/pages/home';
import Header from './componentes/header';

function App() {
  return (
    <div className="App">
      {/* <div className="container page">
        <div className="App-header-logo">
          <div className="row titulo">
            <p className="logo">
              <a className="titulo"> <h1></h1></a></p>
          </div>
        </div> */}
        <header className="App-header">
          <Header />
          <Home />
        </header>
      {/* </div> */}
    </div>
  );
}

export default App;
